import { pushDatalayer } from '~/utilities';

const checkPageDataLayerAwait = () => {
    if (window.pageDataLayerAwait?.length > 0) return;

    pushDatalayer(window.pageDataLayer);
}

window.pageDataLayerAwait = window.pageDataLayerAwait || [];
window.pageDataLayerAwait.forEach(awaitEvent => {
    window.addEventListener(awaitEvent, () => {
        window.pageDataLayerAwait = window.pageDataLayerAwait?.filter(event => event !== awaitEvent) || [];
        checkPageDataLayerAwait();
    });
});

checkPageDataLayerAwait();
